/* eslint-disable react/jsx-no-target-blank */
import {
  Divider,
  Highlight,
  HStack,
  IconButton,
  Image,
  Stack,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import { useEffect } from "react";
import Tilt from "react-parallax-tilt";
import Aos from "aos";
import "aos/dist/aos.css";
import { ImLinkedin2 } from "react-icons/im";
import Recommandation from "./Recommandation";
import Achievements from "./Achivements";

import wave from "../projectimages/wave.png";
import particle from "../projectimages/particle.png";

const About = () => {
  const RecommandBG = useColorModeValue("#f2f6ff", "#252020");

  useEffect(() => {
    Aos.init({ duration: 600 });
  }, []);

  const bg = useColorModeValue("white", "#312e2e");
  const HeadingColor = useColorModeValue("black", "white");
  const QueryColor = useColorModeValue("#e53e3e", "#eac288");

  return (
    <Stack id="about" p={{ base: 0, md: 8 }} w="full" bg={bg}>
      <Stack
        justifyContent={{ base: "space-evenly", sm: "space-around" }}
        alignItems="center"
        p={{ base: 0, sm: 8 }}
        alignSelf="center"
        justify="center"
        w="full"
        maxW="1400px"
      >
        <Tilt>
          <Stack data-aos="zoom-in">
            <Text
              color={HeadingColor}
              textAlign="center"
              marginTop={50}
              fontSize={{ base: "2xl", sm: "2xl", md: "4xl" }}
              fontWeight="semibold"
            >
              <Highlight
                query={["About", "Experience"]}
                styles={{ color: QueryColor }}
              >
                All About Me
              </Highlight>
            </Text>
          </Stack>
        </Tilt>

        <Stack
          justifyContent={{ base: "space-evenly", sm: "space-around" }}
          alignItems="center"
          spacing={5}
          alignSelf="center"
          justify="center"
          w="full"
          maxW="1400px"
          flexFlow={{ base: "column-reverse", lg: "row" }}
          flexDirection={{ base: "column", xl: "row" }}
        >
          <VStack
            data-aos="zoom-in"
            marginTop={{
              base: "-80px",
              sm: "-160px",
              md: "-50px",
              lg: -"160px",
            }}
          >
            <Tilt>
              <Image
                w={{ base: "full", md: "500px", xl: "600px" }}
                src="https://i.ibb.co/JkWdML5/ 68747470733a2f2f63646e2e647269-unscreen.gif"
              />
            </Tilt>
          </VStack>

          <VStack
            data-aos="zoom-in"
            spacing={5}
            p={{ base: 5, sm: 5 }}
            w={{ base: "100%", md: "80%", lg: "50%", xl: "40%" }}
          >
            <Text
              textAlign={{ base: "center", md: "start" }}
              fontSize={{ base: "15px", sm: "15px", lg: "16px" }}
              color="gray"
            >
              Hello! My name is <b>Sufiyan Shaikh</b>, and I’m a passionate{" "}
              <b>Full Stack Web Developer</b> with over 5 years of experience
              building scalable, user-centric web applications. I specialize in{" "}
              <b>
                React.js, Next.js, Node.js (Express), TypeScript, and modern UI
                frameworks
              </b>{" "}
              like Chakra UI, MUI, Tailwind, and ShadCN.
            </Text>

            <Divider borderColor="gray.500" />

            <Text
              textAlign={{ base: "center", md: "start" }}
              fontSize={{ base: "15px", lg: "16px" }}
              color="gray"
            >
              I’ve successfully delivered 18+ projects across domains such as{" "}
              <b>AI, healthcare, real estate, and e-commerce</b>. I enjoy
              turning ideas into interactive, reliable, and high-performing
              digital experiences using clean and maintainable code.
            </Text>

            <Divider borderColor="gray.500" />

            <Text
              textAlign={{ base: "center", md: "start" }}
              fontSize={{ base: "15px", lg: "16px" }}
              color="gray"
            >
              I’m currently open to <b>remote or hybrid opportunities</b> where
              I can contribute to innovative products, collaborate with creative
              teams, and continue learning new technologies.
            </Text>
          </VStack>
        </Stack>
      </Stack>
      <Stack
        overflow={"hidden"}
        justifyContent={{ base: "space-evenly", sm: "space-around" }}
        alignItems="center"
        p={{ base: 0, sm: 8 }}
        alignSelf="center"
        justify="center"
        w="full"
        maxW="100%"
        bg={RecommandBG}
        position="relative"
      >
        <HStack mb={5} mt={5} data-aos="zoom-in">
          <a
            href="https://www.linkedin.com/in/sufiyan-shaikh-developer"
            target="_blank"
          >
            <IconButton
              size="md"
              borderRadius="20px"
              fontSize="xl"
              bg={"#e53e3e"}
              colorScheme="red"
              icon={<ImLinkedin2 />}
            />
          </a>
          <Tilt>
            {" "}
            <Text
              color={HeadingColor}
              textAlign="center"
              fontSize={{ base: "2xl", sm: "2xl", md: "4xl" }}
              fontWeight="semibold"
            >
              <Highlight
                query={["Recommendation", "Experience"]}
                styles={{ color: QueryColor }}
              >
                Linkedin Recommendation
              </Highlight>
            </Text>{" "}
          </Tilt>
        </HStack>

        <Recommandation zIndex={2} />

        <Image
          display={{ base: "none", md: "flex" }}
          opacity={"10%"}
          zIndex={1}
          transform="rotate(180deg)"
          position={"absolute"}
          top="-25"
          left="-100"
          w="355px"
          src={particle}
        />
        <Image
          display={{ base: "none", md: "flex" }}
          opacity={"10%"}
          zIndex={1}
          position={"absolute"}
          bottom="-25"
          right="-100"
          w="355px"
          src={particle}
        />
      </Stack>
      <Stack
        position={"relative"}
        zIndex="2"
        justifyContent={{ base: "space-evenly", sm: "space-around" }}
        alignItems="center"
        p={{ base: 0, sm: 8 }}
        alignSelf="center"
        justify="center"
        w="full"
        maxW="100%"
      >
        <Tilt>
          <Stack data-aos="zoom-in">
            <Text
              color={HeadingColor}
              textAlign="center"
              fontSize={{ base: "2xl", sm: "2xl", md: "4xl" }}
              fontWeight="semibold"
            >
              <Highlight
                query={["Achievements", "Experience"]}
                styles={{ color: QueryColor }}
              >
                Personal Achievements
              </Highlight>
            </Text>
          </Stack>
        </Tilt>

        <Achievements />

        <Image
          w="100%"
          opacity={"50%"}
          backdropFilter={"inherit"}
          bottom={0}
          zIndex={"-1"}
          src={wave}
          position="absolute"
        />
      </Stack>
    </Stack>
  );
};

export default About;
